"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 14 18';

var Lock = function Lock() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M12.2322667,5.71107692 L11.4117111,5.71107692 L11.4117111,4.088 C11.4117111,1.84876923 9.57382222,0.0303076923 7.30893333,0.0303076923 C5.04482222,0.0303076923 3.20693333,1.84876923 3.20693333,4.088 L3.20693333,5.71107692 L2.38637778,5.71107692 C1.48415556,5.71107692 0.744488889,6.44107692 0.744488889,7.33338462 L0.744488889,15.4487692 C0.744488889,16.3410769 1.48415556,17.0718462 2.38637778,17.0718462 L12.2322667,17.0718462 C13.1344889,17.0718462 13.8726,16.3410769 13.8726,15.4487692 L13.8726,7.33338462 C13.8726,6.44107692 13.1344889,5.71107692 12.2322667,5.71107692 Z M7.30893333,13.0141538 C6.40671111,13.0141538 5.6686,12.2841538 5.6686,11.3910769 C5.6686,10.4987692 6.40671111,9.768 7.30893333,9.768 C8.21193333,9.768 8.95004444,10.4987692 8.95004444,11.3910769 C8.95004444,12.2841538 8.21193333,13.0141538 7.30893333,13.0141538 Z M9.85226667,5.71107692 L4.7656,5.71107692 L4.7656,4.088 C4.7656,2.70030769 5.90582222,1.57184615 7.30893333,1.57184615 C8.71282222,1.57184615 9.85226667,2.70030769 9.85226667,4.088 L9.85226667,5.71107692 Z"
  }));
};

var _default = (0, _createSvgIcon["default"])(Lock, {
  viewBox: viewBox
});

exports["default"] = _default;